/**
 * Returns a sorting value for use with k-table sortBy property
 * Sorts competencies by category (Knowledge -> Skill -> Behaviour) and then by number
 * @param {Object} competency - Competency label
 * @returns {Number} Sorting value for the competency
 */
export function competencySortBy(competency) {
  const categoryOrder = { K: 1, S: 2, B: 3 };
  const categoryValue = categoryOrder[competency.charAt(0)];
  const numberValue = parseInt(competency.substring(1), 10);
  return [categoryValue, numberValue];
}

export default competencySortBy;
